var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { action, observable, computed } from 'mobx';
import { observer } from 'mobx-react';
import { Select } from '@app/Components/Select/Select';
import { Api } from '@app/Api';
export var UniqueIdPicker = /** @class */ (function (_super) {
    __extends(UniqueIdPicker, _super);
    function UniqueIdPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._selectedValue = null;
        _this._uniqueIds = [];
        _this._handleSelectChange = function (selectedValue) { return __awaiter(_this, void 0, void 0, function () {
            var option;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (selectedValue && !Array.isArray(selectedValue)) {
                            option = selectedValue;
                            this._selectedValue = option;
                        }
                        else {
                            this._selectedValue = null;
                        }
                        return [4 /*yield*/, ((_b = (_a = this.props).onChangeHandler) === null || _b === void 0 ? void 0 : _b.call(_a, this._selectedValue))];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    UniqueIdPicker.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var defaultValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        defaultValue = this.props.defaultValue;
                        return [4 /*yield*/, this._loadSecurableObjects()];
                    case 1:
                        _a.sent();
                        this._selectedValue = this._getDefaultOption(defaultValue);
                        return [2 /*return*/];
                }
            });
        });
    };
    UniqueIdPicker.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.props.value !== prevProps.value) {
                    this._selectedValue = this.props.value;
                }
                return [2 /*return*/];
            });
        });
    };
    UniqueIdPicker.prototype._loadSecurableObjects = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, Api.secured.searchSecurableObject({ term: this._searchTerm })];
                    case 1:
                        _a._uniqueIds = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UniqueIdPicker.prototype._getDefaultOption = function (defaultValue) {
        if (!defaultValue || !this._uniqueIds.length)
            return undefined;
        var option = this._uniqueIdOptions.find(function (x) { return x.value === defaultValue; });
        return option ? { value: option.value, label: option.label } : undefined;
    };
    UniqueIdPicker.prototype._handleInputChange = function (newValue) {
        if (newValue && newValue !== this._searchTerm) {
            this._searchTerm = newValue;
            //_handleInputChange should be synchronous
            this._loadSecurableObjects()
                .then(function () { return undefined; })
                .catch(function () { return undefined; });
        }
    };
    Object.defineProperty(UniqueIdPicker.prototype, "_uniqueIdOptions", {
        get: function () {
            return this._uniqueIds.map(function (x) { return ({ label: x, value: x }); });
        },
        enumerable: false,
        configurable: true
    });
    UniqueIdPicker.prototype.render = function () {
        return (React.createElement(Select, { options: this._uniqueIdOptions, onChange: this._handleSelectChange, onInputChange: this._handleInputChange, defaultValue: this._selectedValue, value: this._selectedValue, isClearable: true }));
    };
    __decorate([
        observable
    ], UniqueIdPicker.prototype, "_searchTerm", void 0);
    __decorate([
        observable
    ], UniqueIdPicker.prototype, "_selectedValue", void 0);
    __decorate([
        observable
    ], UniqueIdPicker.prototype, "_uniqueIds", void 0);
    __decorate([
        action.bound
    ], UniqueIdPicker.prototype, "_loadSecurableObjects", null);
    __decorate([
        action.bound
    ], UniqueIdPicker.prototype, "_handleSelectChange", void 0);
    __decorate([
        action.bound
    ], UniqueIdPicker.prototype, "_handleInputChange", null);
    __decorate([
        computed
    ], UniqueIdPicker.prototype, "_uniqueIdOptions", null);
    UniqueIdPicker = __decorate([
        observer
    ], UniqueIdPicker);
    return UniqueIdPicker;
}(React.Component));
